import { render, staticRenderFns } from "./LeaveHistory.vue?vue&type=template&id=9df67904&scoped=true"
import script from "./LeaveHistory.vue?vue&type=script&lang=js"
export * from "./LeaveHistory.vue?vue&type=script&lang=js"
import style0 from "./LeaveHistory.vue?vue&type=style&index=0&id=9df67904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9df67904",
  null
  
)

export default component.exports